import { MapPin, Phone, Mail, Globe } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-[#F9F8F4] pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="mb-6">
            <div className="font-serif text-2xl tracking-tight">Bolt <span className="italic text-[#E5C9A8]">Modular</span></div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#C9BFA9] mt-1">A unit of JJ Lumbers</div>
          </div>
          <p className="text-sm text-[#C9BFA9] max-w-md leading-relaxed">
            Precision-crafted modular interiors rooted in 25+ years of material
            excellence. From timber to turnkey — designed better, built stronger,
            made to last.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-serif text-lg mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-[#C9BFA9]">
            <li><a href="#services" className="hover:text-[#F9F8F4]">Services</a></li>
            <li><a href="#doors" className="hover:text-[#F9F8F4]">Doors</a></li>
            <li><a href="#projects" className="hover:text-[#F9F8F4]">Projects</a></li>
            <li><a href="#materials" className="hover:text-[#F9F8F4]">Materials</a></li>
            <li><a href="#contact" className="hover:text-[#F9F8F4]">Contact</a></li>
            <li><Link to="/admin/login" className="hover:text-[#F9F8F4]">Admin</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-serif text-lg mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm text-[#C9BFA9]">
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-[#8C5931]"/>Plot No. 1, Near Bakhra Bridge,<br/>Main Kachwa Road, Pundrak, Karnal, Haryana</li>
            <li className="flex items-center gap-3"><Phone size={16} className="text-[#8C5931]"/><a href="tel:+919084888887" className="hover:text-[#F9F8F4]">+91 90848 88887</a></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#8C5931]"/><a href="mailto:jjlumbers07@gmail.com" className="hover:text-[#F9F8F4]">jjlumbers07@gmail.com</a></li>
            <li className="flex items-center gap-3"><Globe size={16} className="text-[#8C5931]"/>www.boltmodular.in</li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-14 pt-6 border-t border-[#3a3530] flex flex-col md:flex-row justify-between gap-3 text-xs text-[#9c948a]">
        <p>© {new Date().getFullYear()} Bolt Modular · JJ Lumbers. All rights reserved.</p>
        <p>Authorised OEM cum Distributor — Greenpanel Industries.</p>
      </div>
    </footer>
  );
}
